import React from 'react';
import { injectIntl, defineMessages, IntlShape } from 'react-intl';
import { UUID } from 'src/types/utility';
import AlertLogTable from './AlertLogTable';

import { StyledModal } from './styled';

type Props = {
  subtenantId: UUID;
  subtenantName: string;
  isModalVisible: boolean;
  setIsModalVisible: (isVisible: boolean) => void;
  intl: IntlShape;
};

const SubtenantAlertLogModal = ({
  subtenantId,
  subtenantName,
  isModalVisible,
  setIsModalVisible,
  intl,
}: Props): JSX.Element => {
  return (
    <StyledModal
      title={`${subtenantName} ${intl.formatMessage(messages.title)}`}
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      destroyOnClose={true}
      width="60rem"
    >
      <AlertLogTable subtenantId={subtenantId} />
    </StyledModal>
  );
};

const messages = defineMessages({
  title: {
    defaultMessage: 'Notification Log',
  },
});

export default injectIntl(SubtenantAlertLogModal);
